<template class="chart">
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="optionsData"
    :show-description="showDescription"
    :has-custom-filter="hasCustomFilter"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <div
      ref="chartdiv"
      class="gauge-chart"
    />

    <template #top-right-slot>
      <template v-if="hasCustomFilter">
        <DsButton
          v-tooltip="filterButton"
          color="tertiary"
          name="filter"
          :icon="true"
          @click="openFilter"
        />
      </template>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
      <DsButton
        v-if="showDescription"
        v-tooltip="infoLabel"
        color="tertiary"
        name="questions"
        :icon="true"
        @click="openDialog"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import cardsModel from '@/mixins/cards-model';
import gaugeModel from '@/mixins/gauge-model';
import exportModel from '@/mixins/export-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import Badge from '@/components/Badge';
import { DsButton } from '@ds/components';

export default {
  name: 'PercentGauge',
  components: {
    CardWithTitle,
    Badge,
    DsButton,
  },
  mixins: [
    cardsModel,
    gaugeModel,
    exportModel,
  ],
  props: {
    score: {
      type: Object,
      default: () => {
        return { value: 0 };
      },
    },
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    openDialog: {
      type: Function,
      default: () => {},
    },
    showDescription: {
      type: Boolean,
      required: false,
    },
    hasCustomFilter: {
      type: Boolean,
      default: false,
    },
    openFilter: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      chartMin: 0,
      chartMax: 100,
      gradingData: [
        {
          title: '',
          color: '#ee1f25',
          lowScore: -1,
          highScore: 20,
        },
        {
          title: '',
          color: '#ee5757',
          lowScore: 20,
          highScore: 40,
        },
        {
          title: '',
          color: '#fdae19',
          lowScore: 40,
          highScore: 60,
        },
        {
          title: '',
          color: '#b0d136',
          lowScore: 60,
          highScore: 80,
        },
        {
          title: '',
          color: '#0f9747',
          lowScore: 80,
          highScore: 100,
        },
      ],
      matchingGrade: [],
      axis2: '',
    };
  },

  computed: {
    infoLabel() {
      return this.$t('components.OperatorsLogs.infoLabel');
    },
    filterButton() {
      return this.$t('components.OperatorsLogs.filterLabel');
    },
    optionsData() {
      return this.baseCardOptions.concat(this.exportOptionsData).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
    },
  },

  methods: {
    setLabel() {
      const label = this.chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = '4em';
      label.x = am4core.percent(50);
      label.paddingBottom = -5;
      label.horizontalCenter = 'middle';
      label.verticalCenter = 'bottom';
      label.text = `${this.score.value.toFixed()}%`;
      label.fill = am4core.color(this.matchingGrade.color);
    },
  },
};
</script>

<style scoped>
  .gauge-chart {
    font-size: 1.2rem;
  }
</style>
